/**
 * Maaş Zammı Hesaplama Engine
 */

export const YILI = 2026;
export const BRUT_ASGARI_UCRET = 33_030;

export interface MaasZammiGirdi {
  mevcutMaas: number;
  zamOrani?: number; // yüzde olarak (ör: 25 => %25)
  hedefMaas?: number;
}

export interface MaasZammiSonuc {
  mevcutMaas: number;
  zamOrani: number;
  zamMiktari: number;
  yeniMaas: number;
  yillikFark: number;
  enflasyonKarsilastirma: {
    tufe: number;
    reelZam: number;
  };
}

// 2025 yıllık TÜFE tahmini (kaynak: TCMB)
export const TUFE_2025_YILLIK = 30.89; // %30.89 (TÜİK Aralık 2025 gerçekleşme)

export function formatTL(value: number): string {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function hesaplaMaasZammi(girdi: MaasZammiGirdi): MaasZammiSonuc {
  const mevcutMaas = Math.max(0, girdi.mevcutMaas || 0);

  let zamOrani: number;
  let zamMiktari: number;
  let yeniMaas: number;

  if (girdi.hedefMaas && girdi.hedefMaas > 0) {
    // Hedef maaştan zam oranı hesapla
    yeniMaas = girdi.hedefMaas;
    zamMiktari = yeniMaas - mevcutMaas;
    zamOrani = mevcutMaas > 0 ? (zamMiktari / mevcutMaas) * 100 : 0;
  } else {
    // Zam oranından yeni maaş hesapla
    zamOrani = Math.max(0, girdi.zamOrani || 0);
    zamMiktari = mevcutMaas * (zamOrani / 100);
    yeniMaas = mevcutMaas + zamMiktari;
  }

  const yillikFark = zamMiktari * 12;
  const reelZam = zamOrani - TUFE_2025_YILLIK;

  return {
    mevcutMaas,
    zamOrani,
    zamMiktari,
    yeniMaas,
    yillikFark,
    enflasyonKarsilastirma: {
      tufe: TUFE_2025_YILLIK,
      reelZam,
    },
  };
}
